import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  DevicesStore,
  InstallationFeaturesStore,
  TrendingDateseriesError,
  TrendingType,
  TrendingTypeEnum,
} from '@store';
import { Observable, Subject, takeUntil } from 'rxjs';

import { TrendingData, TrendingStore } from '@store';

import { TrendChartsLabels } from './trending-charts-labels';
import { TrendingViUnifyModalComponent } from './trending-viunify-modal/trending-viunify-modal.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';
import { matTooltipSetter } from 'src/app/shared/functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-trending',
  templateUrl: './trending.component.html',
  styleUrls: ['./trending.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrendingComponent implements OnInit, OnDestroy {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }
  TrendingDateseriesError = TrendingDateseriesError;
  trendingType = TrendingTypeEnum;
  trendingData$: Observable<TrendingData>;
  trends = new TrendChartsLabels(this.translateService);
  currentTab: TrendingTypeEnum;
  viunifyDialogRef: MatDialogRef<TrendingViUnifyModalComponent>;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    public devicesStore: DevicesStore,
    public installationFeaturesStore: InstallationFeaturesStore,
    protected trendingStore: TrendingStore,
    private translateService: TranslateService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.devicesStore.updateBatteryHasLargestModules();
    this.trendingData$ = this.trendingStore.dataSeries$;
    this.trendingStore.getDataSeries();
    this.trendingStore.selectTrendingTabData();
    this.trendingStore.selectTrendingTabData$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((trendingTabData) => {
        this.currentTab = trendingTabData.find((tab) => tab.isActive).type;
        if (trendingTabData.some((tab) => tab.type === this.trendingType.ENERGY_STORAGE)) {
          this.trendingStore.getEnergyStorageLabels();
        }
      });
  }

  switchTab(trendingType: TrendingType): void {
    this.trendingStore.setActiveTrendingType(trendingType);
    this.currentTab = trendingType;
  }

  openViUnifyModal(): void {
    this.viunifyDialogRef = this.dialog.open(TrendingViUnifyModalComponent, {
      width: '710px',
      panelClass: 'trending-viunify-modal',
      autoFocus: false,
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.trendingStore.clearTrendingStore();
  }
}
